module.exports = __webpack_public_path__ + "images/street-names-28a809576669191ca20ba4e3752e26a1.jpg";